/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : smartMatchSuggestionActions.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../../actionTypes";

const smartMatchActions = {
  get_suggestions: {
    api_name: "/smartMatch/api/v1/recommendations",
    https_method: "POST",
    action_type: actionType.GET_SMART_MATCH_SUGGESTIONS,
    description: "API to fetch smart match suggestions",
  },
  clear_suggestions: {
    action_type: actionType.CLEAR_SMART_MATCH_SUGGESTIONS,
    description: "Action to clear smart match suggestions from store",
  },
  submit_feedback: {
    action_type: actionType.SMART_MATCH_SUBMIT_FEEDBACK,
    https_method: "POST",
    api_name: "/smartMatch/api/v1/recommendations/feedback",
    description: "API to submit feedback for smart match suggestions",
  },
  refresh_kg_nodes: {
    action_type: actionType.REFRESH_KG_NODES,
    https_method: "POST",
    api_name: "/smartMatch/api/v1/kg/enrich/bulk",
    description: "API to refresh knowledge graph nodes",
  },
  refresh_kg_nodes_decision_matrix: {
    action_type: actionType.REFRESH_KG_NODES_DECISION_MATRIX,
    https_method: "POST",
    api_name: "/smartMatch/api/v1/kg/enrich/bulk",
    description: "API to refresh knowledge graph nodes",
  },
  get_decision_matrix_ai_suggestions: {
    action_type: actionType.GET_DECISION_MATRIX_AI_SUGGESTIONS,
    https_method: "POST",
    api_name: "/smartMatch/api/v1/kg/enrich/bulk/decisionmatrix",
    description: "API to get decision matrix AI suggestions",
  },
  get_live_stream_queue: {
    action_type: actionType.GET_LIVE_STREAM_QUEUE,
    https_method: "GET",
    api_name: "/smartMatch/api/v1/kg/queue/stream",
    description: "API to get live stream queue",
  },
};

export default smartMatchActions;
